import React from 'react';

export default function PageWrapper({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <div className="bg-background mt-[90px] overflow-hidden rounded-tl-[20px] rounded-tr-[20px] pb-[90px] max-md:mt-[70px]">
            {children}
        </div>
    );
}
